<template>
  <div v-html="require(`!html-loader!../../../assets/icons/svg/${icon}.svg`)" class="svg-container"></div>
</template>

<script>
  function recursivelyRemoveFill(el) {
    if (!el) {
      return;
    }
    el.removeAttribute('fill');
    [].forEach.call(el.children, child => {
      recursivelyRemoveFill(child);
    });
  }
  export default {
    name: "AppSvgIcon",
    props: {
      icon: {
        type: String,
        required: true
      },
      hasFill: {
        type: Boolean,
        default: false
      },
      growByHeight: {
        type: Boolean,
        default: true
      },
      height: {
        type: String,
        default: null
      },
      width: {
        type: String,
        default: null
      },
    },
    mounted() {
      if (this.$el.firstElementChild.nodeName === 'svg') {
        const svgElement = this.$el.firstElementChild;
        // use `viewBox` attribute to get the svg's inherent width and height
        const viewBox = svgElement.getAttribute('viewBox').split(' ').map(n => Number(n));
        const widthToHeight = (viewBox[2] / viewBox[3]).toFixed(2);
        if (this.hasFill) {
          // recursively remove all fill attribute of element and its nested children
          recursivelyRemoveFill(svgElement);
        }
        if (this.height || this.width) {
          svgElement.removeAttribute('height');
          svgElement.removeAttribute('width');
          if (this.height) {
            svgElement.setAttribute('height', this.height);
          }
          if (this.width) {
            svgElement.setAttribute('width', this.width);
          }
        } else {
          // set width and height relative to font size
          // if growByHeight is true, height set to 1em else width set to 1em and remaining is calculated based on widthToHeight ratio
          if (this.growByHeight) {
            svgElement.setAttribute('height', '1em');
            svgElement.setAttribute('width', `${widthToHeight}em`);
          } else {
            svgElement.setAttribute('width', '1em');
            svgElement.setAttribute('height', `${1 / widthToHeight}em`);
          }
        }
        svgElement.classList.add('svg-class');
      }
    }
  }
</script>

<style scoped>
  .svg-container {
    display: inline-block;
  }
</style>
